import { useNavigate } from 'react-router-dom';
import TaskCreate from './TaskCreate';

export default function TaskCreatePage() {
  const navigate = useNavigate();
  const close = () => navigate('/tasks/list');
  return <TaskCreate isOpen onClose={close} onSuccess={close} />;
}
